import { useEffect } from 'react';
import { useQuery } from '@apollo/client';
import { useProcess } from '@fasstech/oip-starter-utils/app';
import { pathOr } from 'ramda';
import { isProjectBlocked } from '@@viewEnums';
import { GetProjectStatusQuery } from '../graphql/queries/GetProjectStatus.js';

/**
 * Tells if the current project is in a blocking status
 */
export const useProjectBlocked = () => {
  const { context } = useProcess();
  const { data } = useQuery(GetProjectStatusQuery, {
    fetchPolicy: 'cache-and-network'
  });

  const projectStatus = pathOr(null, ['getProject', 'data', 'status'], data);
  const projectId =
    context?.projectId ?? pathOr(null, ['getProject', 'data', 'id'], data);
  const isBlocked = isProjectBlocked(projectStatus);

  useEffect(() => {
    if (isBlocked) {
      console.log(
        `[projectLock] project ${projectId} is blocked (status=${projectStatus}): navigation and edits disabled`
      );
    }
  }, [isBlocked, projectId, projectStatus]);

  return { isBlocked, projectStatus, projectId };
};

export default useProjectBlocked;
